import { c as _c } from "react/compiler-runtime";
import { brightenColor, darkenColor, decodeColor, getColorLuminance } from 'betterplace-utils';
import { useEffect, useRef, useState } from 'react';
function useDeltaColor(progressPercentage, intervalMs, progressColor, progressBackgroundColor, darkMode) {
  const $ = _c(9);
  const color = decodeColor(progressColor?.toString()) || "";
  const backgroundColor = decodeColor(progressBackgroundColor?.toString());
  const [delta, setDelta] = useState(0);
  const previousPercentage = useRef(0);
  let t0;
  let t1;
  if ($[0] !== intervalMs || $[1] !== progressPercentage) {
    t0 = () => {
      setDelta(progressPercentage - previousPercentage.current);
      const timeout = setTimeout(() => {
        setDelta(0);
        previousPercentage.current = progressPercentage;
      }, Math.round(intervalMs * 0.75));
      return () => clearTimeout(timeout);
    };
    t1 = [intervalMs, progressPercentage];
    $[0] = intervalMs;
    $[1] = progressPercentage;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  const backgroundLuminance = backgroundColor && backgroundColor !== "transparent" ? getColorLuminance(backgroundColor) : darkMode ? 0 : 1;
  const luminanceDiff = getColorLuminance(color) - backgroundLuminance;
  const increaseDiff = luminanceDiff <= 0 ? darkenColor : brightenColor;
  const decreaseDiff = luminanceDiff <= 0 ? brightenColor : darkenColor;
  const deltaColor = (Math.abs(luminanceDiff) > 0.49 ? decreaseDiff : increaseDiff)(color, 40);
  let t2;
  if ($[4] !== backgroundColor || $[5] !== color || $[6] !== delta || $[7] !== deltaColor) {
    t2 = {
      delta,
      deltaColor,
      color,
      backgroundColor
    };
    $[4] = backgroundColor;
    $[5] = color;
    $[6] = delta;
    $[7] = deltaColor;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}
export default useDeltaColor;